module.exports = __webpack_public_path__ + "img/政府合作项目icon.98cfb826.png";